<h1>{{"gipReqResetForm" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Title"}}</h1>
<app-formular [formBuilderInput]="modelInput" [formular]="formular"></app-formular>

<button mat-raised-button>RESET_PLOTEXPO</button>
<button mat-raised-button>RESET_PLOTEXPO_ALL</button>
<button mat-raised-button>RESET_REQ_META</button>
<button mat-raised-button>BACK</button>
